// The destinations of the site bar, in ONE place, because there are now two bars carrying them: the bar at the top
// of every annex page (components/site-nav.tsx) and the relay capsule that takes over on scroll
// (components/site-fixed-nav.tsx). Two lists would be two lists to update, and this repo has already paid that bill
// — site-nav.css was a copy of home-v2/nav.css, they drifted, and Jérémy reported the same defect twice (19/09).
//
// Every label and destination already existed (the three old navs and the v2 footer): nothing is reworded, nothing
// is invented. "Careers" was here until 19/09 and now lives in the footer alone — so no item points at /hiring, and
// /hiring marks nothing as current.

/**
 * The page a bar is drawn for. It does two things, and only the first needs the page to be IN the list: it marks
 * the matching item aria-current, and it picks the ink of the top bar (see DARK_HEAD in site-nav.tsx).
 * "/hiring" is deliberately kept although Careers left the list: it marks nothing — a page absent from the menu has
 * no current item to show — but it is what tells the top bar to draw itself in white over the dusk photo.
 */
export type SiteNavCurrent = "/skills" | "/blog" | "/hiring" | "/contact";

export const SITE_NAV_LINKS = [
  { label: "Why Claude", href: "/#why" },
  { label: "North OS", href: "/#northos" },
  { label: "North Deploy", href: "/#deploy" },
  { label: "Skills", href: "/skills" },
  { label: "Blog", href: "/blog" },
] as const;
